<template>
    <v-app>
        <Toolbar title="Device Detail"/>
        <v-content>
            <v-layout row>
                <v-flex xs12 sm12 offset-sm0>
                    <v-card>
                        <v-card-title primary-title>
                            <v-btn @click="$router.push({path: '/group/' + groupId})">
                                <v-icon dark>arrow_back</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div>
                                <div class="headline">{{ deviceId }}</div>
                                <span class="grey--text">Group: {{ groupName }}</span>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>

            </v-layout>


            <v-container grid-list-md>
                <v-layout row wrap>

                    <v-flex xs12 sm12 text-sm-center v-if="token !== undefined">
                        <span v-if="token['timestamp']">Device last connected to cloud on {{ timeConverter(token['timestamp']['seconds']) }}</span>
                        <!-- <span v-else>Device has never connected to cloud</span> -->
                    </v-flex>

                    <v-flex xs12 sm6 md5 v-if="Object.keys(status).length !== 0">
                        <v-item-group multiple>
                            <v-subheader>Hardware</v-subheader>
                            <v-chip label v-if="status.model">{{ status.model.toUpperCase() }}</v-chip>
                            <v-chip label v-if="status['portable']">Battery</v-chip>
                            <v-chip label v-if="status['terminal.bluetooth']">Bluetooth</v-chip>
                            <v-chip label v-if="status['terminal.ethernet']">Ethernet</v-chip>
                            <v-chip label v-if="status['terminal.gprs']">GSM</v-chip>
                            <v-chip label v-if="status['terminal.screen_height'] && status['terminal.screen_width']">{{
                                status['terminal.screen_width'] }} x {{ status['terminal.screen_height'] }}
                            </v-chip>
                            <v-chip label v-if="status['terminal.printer']">Printer</v-chip>
                            <v-chip label v-else>No printer</v-chip>
                            <v-chip label v-if="status['terminal.touchscreen']">Touchscreen</v-chip>
                            <v-chip label v-else>No touchscreen</v-chip>
                            <v-chip label v-if="status['terminal.usb']">USB</v-chip>
                            <v-chip label v-if="status['terminal.wifi']">Wi-Fi</v-chip>
                        </v-item-group>
                    </v-flex>
                    <v-flex xs12 sm6 md5 v-if="Object.keys(status).length !== 0">
                        <v-item-group multiple>
                            <v-subheader>Application</v-subheader>
                            <v-chip label v-if="status.host">{{ status.host.toUpperCase() }}</v-chip>
                            <v-chip label v-if="status.version">Version: {{ status.version }}</v-chip>
                            <v-chip label v-if="status['connection']['mode']">Connected: {{
                                status['connection']['mode'].toUpperCase() }}
                            </v-chip>
                            <v-chip label v-if="status['autoupdate.last_update']">Last update: {{
                                timeConverter(status['autoupdate.last_update']) }}
                            </v-chip>
                            <v-chip label v-else>Never updated</v-chip>
                            <v-chip label v-if="status['update_ready']">Update ready</v-chip>
                            <v-chip label v-else>No update ready</v-chip>
                            <v-chip label v-if="status['start']">Starts: {{ status['start'] }}</v-chip>
                            <v-chip label v-if="status['emv.insert']">Inserts: {{ status['emv.insert'] }}</v-chip>
                            <v-chip label v-if="status['emv.tap']">Taps: {{ status['emv.tap'] }}</v-chip>
                        </v-item-group>
                    </v-flex>
                    <v-flex xs12 sm12 v-else>
                        <v-alert
                                :value="true"
                                color="info"
                                icon="info"
                                outline
                        >No device statistics
                        </v-alert>
                    </v-flex>
                    <v-flex xs12 sm12 md2>
                        <v-item-group multiple>
                            <v-subheader>Actions</v-subheader>
                            <v-btn block color="info"
                                   @click="$router.push({path: '/settings/' + groupId + '/' + deviceId})">View Settings
                            </v-btn>
                            <v-btn block color="info" @click="clearToken">Clear Token</v-btn>
                            <v-btn block color="info"
                                   @click="$router.push({path: '/stats/' + groupId + '/' + deviceId})"  v-if="Object.keys(status).length !== 0">View Stats
                            </v-btn>
                            <v-btn block color="info"
                                   @click="$router.push({path: '/log/' + groupId + '/' + deviceId})"  v-if="Object.keys(status).length !== 0">Cloud Log
                            </v-btn>
                            <!-- <v-btn block color="info"
                                   @click="$router.push({path: '/report/' + groupId + '/' + deviceId})">Report
                            </v-btn> -->
                        </v-item-group>
                    </v-flex>


                </v-layout>

            </v-container>

            <TransactionList :id="deviceId" :group="groupId"/>

            <v-layout row wrap>
                <DeviceMirror :id="deviceId" :group="groupId"/>
                <DeviceMoveGroup :id="deviceId"/>
                <DeviceDelete :id="deviceId" :group="groupId"/>
            </v-layout>

        </v-content>

    </v-app>
</template>

<script>
    import {mapActions} from 'vuex'
    import Toolbar from '../components/Toolbar'
    import TransactionList from '../components/TransactionList'
    import DeviceMoveGroup from '../components/DeviceMoveGroup'
    import DeviceDelete from '../components/DeviceDelete'
    import DeviceMirror from '../components/DeviceMirror'

    const fb = require('../firebase')

    export default {
        name: "Device",
        components: {Toolbar, TransactionList, DeviceMoveGroup, DeviceDelete, DeviceMirror},
        data() {
            return {
                token: {},
                status: {}
            }
        },
        mounted() {
            if (this.deviceId === undefined || this.deviceId === 'undefined') {
                this.$router.push({path: '/groups'})
            }
            this.fetchAll()
            this.fetchToken()
            this.fetchLastState()
        },
        computed: {
            groupId: function () {
                return this.$route.params['group_id']
            },
            groupName: function () {
                let group = this.$store.state.groups[this.groupId]

                if (group !== undefined) {
                    return group.name
                }
                return ''
            },
            deviceId: function () {
                return this.$route.params['device_id']
            }
        },
        methods: {
            ...mapActions(['fetchAll']),
            fetchToken: function () {
                fb.tokensCollection.doc('castles_' + this.deviceId + '@kineticsmart.com').get()
                    .then((token) => {
                        this.token = token.data()
                    })
            },
            fetchLastState: function () {
                fb.statusesCollection
                    .where('id', '==', 'castles_' + this.deviceId + '@kineticsmart.com')
                    .orderBy('timestamp', 'desc')
                    .limit(1)
                    .get()
                    .then((statuses) => {
                        if (!statuses.empty) {
                            statuses.forEach((status) => {
                                this.status = status.data()
                            })
                        }
                    })
            },
            timeConverter: function (UNIX_timestamp) {
                let a = new Date(parseInt(UNIX_timestamp) * 1000);
                let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                let year = a.getFullYear();
                let month = months[a.getMonth()];
                let date = a.getDate();
                let hour = a.getHours();
                let min = a.getMinutes();
                let sec = a.getSeconds();
                return date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
            },
            clearToken: function () {
                fb.tokensCollection
                    .doc('castles_' + this.deviceId + '@kineticsmart.com')
                    .delete()
                    .then(() => {
                        this.$store.commit('showSnack', 'Token cleared.')
                    })
            }
        }
    }
</script>

<style scoped>

</style>
